import StarBorderOutlinedIcon from '@mui/icons-material/StarBorderOutlined'

export const SearchAllIcon = StarBorderOutlinedIcon
export default SearchAllIcon
